import moment from "moment";
import "moment/locale/sv";
import "chart.js/auto";
import { Line } from "react-chartjs-2";
import 'chartjs-adapter-moment';

function LineChart({data}: any) {
    moment.locale("sv");
    const chartData = {
        labels: data.labels,
        datasets: [
            {
                data: data.dataset,
                fill: false,
                backgroundColor: '#036C8F',
                borderColor: '#036C8F',
                tension: 0.4,
                pointRadius: 1
            }
        ]
    };

    return <Line
        data={chartData}
        height='240'
        options={{
            maintainAspectRatio: false,
            animation: false,
            scales: {
                x: {
                    ticks: {
                        align: 'start',
                        stepSize: 11,
                        color: '#F9F9FA',
                    },
                    grid: {
                        display: false,
                    },
                    type: 'time',
                    time: {
                        unit: "month",
                        tooltipFormat:'MMMM YYYY',
                        displayFormats: {
                            month: 'YYYY',
                        }
                    }
                },
                y: {
                    beginAtZero: true,
                    grid: {
                        color: '#545B66',
                        drawTicks: false,
                    },
                    border: {
                        display: false,
                    },
                    ticks: {
                        crossAlign: 'near',
                        maxTicksLimit: 7,
                        padding: 10,
                        color: '#F9F9FA',
                        callback: (value) => {
                            return value.toLocaleString('sv');
                        },
                    },
                    title: {
                        display: true,
                        text: 'Antal jobbannonser',
                        color: '#C8C8CE',
                        font: {
                            size: 10,
                        },
                        padding: 0,
                    },
                }
            },
            plugins: {
                title: {
                    display: false,
                },
                legend: {
                    display: false,
                },
                tooltip: {
                    callbacks: {
                        label: (item) => {
                            return ' ' + item.formattedValue.replace(',', ' ');
                        }
                    },
                },
            }
        }}
    />
}

export default LineChart;